<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Спросы</strong>
                </CCardHeader>
                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <DemandsTable
                            class="mt-4"
                            :data.sync="data"
                            @select="(id) => $router.push(`demands/${id}`)"
                        />
                    </template>
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="$router.push(`demands/create`)"
                    >Создать</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import DemandsTable from '@/components/demands/DemandsTable';

    export default {
        name: 'DemandsList',

        components: {
            DemandsTable,
        },

        data() {
            return {
                loading: true,
                data: [],
            };
        },

        async created() {
            await Promise.all([this.fetchList()]);
            this.loading = false;
        },

        methods: {
            async fetchList() {
                const response = await this.axios.get('/demands');
                this.data = response.data;
            }
        },
    };
</script>
